import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40891578"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg bg-white sticky-top" }
const _hoisted_2 = { class: "container-lg py-1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/lubanzi-inala_logo.svg",
  class: "w-100 img-fluid",
  alt: "Lubanzi Inala"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  class: "collapse navbar-collapse justify-content-lg-end",
  id: "NavDropdown"
}
const _hoisted_7 = { class: "navbar-nav text-uppercase" }
const _hoisted_8 = { class: "nav-item mx-0 mx-lg-2" }
const _hoisted_9 = { class: "nav-item mx-0 mx-lg-2" }
const _hoisted_10 = { class: "nav-item mx-0 mx-lg-2" }
const _hoisted_11 = { class: "nav-item ms-3 ms-lg-2 mt-2 mt-lg-0" }

import { scrollTop } from "@/utils/functions"
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

    function homeScroll () {
        if(window.scrollY == 0) {
            return
        }
        
        setTimeout(() => {
            scrollTop('')
        }, 50)
    }
    function toggleClick () {
        const menu: HTMLElement | null = document.querySelector(".navbar-toggler:not([aria-expanded='false'])")
        if (menu) {
            document.querySelector("main")!.addEventListener("click", collapseMenu);
        }
        else {
            document.querySelector("main")!.removeEventListener("click", collapseMenu);
        }
    }
    function collapseMenu () {
        const hamburgerMenu: HTMLElement | null = document.querySelector(".navbar-toggler:not([aria-expanded='false'])")
        if (hamburgerMenu && hamburgerMenu.offsetWidth > 0 && hamburgerMenu.offsetHeight > 0) {
            hamburgerMenu.click();
        }
        document.querySelector("main")!.removeEventListener("click", collapseMenu);
    }
    

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "navbar-brand logo-style",
        to: { name: 'Home' },
        onClick: _cache[0] || (_cache[0] = ($event: any) => (homeScroll()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createElementVNode("button", {
        class: "navbar-toggler",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleClick())),
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#NavDropdown",
        "aria-controls": "NavDropdown",
        "aria-expanded": "false",
        "aria-label": "Toggle navigation"
      }, _hoisted_5),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              class: "nav-link text-primary px-3",
              to: { name: 'AboutUs' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("About Us")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "nav-link text-primary px-3",
              to: { name: 'WhatWeDo' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("What We Do")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              class: "nav-link text-primary px-3",
              to: { name: 'Partners' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("Partners")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createVNode(_component_router_link, {
              class: "btn btn-primary px-4",
              to: { name: 'ContactUs' }
            }, {
              default: _withCtx(() => [
                _createTextVNode("Contact Us")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}
}

})